import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SecondBar from '../layout/SecondBar';
import i18n from '../../../shared/locales/no.json';
import { createUrl } from '../../utils/createUrl';
import EditProfileStatus from '../EditProfile/components/EditProfileStatus';

export default class ProfileViewToolbarUI extends React.Component {
    static propTypes = {
        isProfileOwner: PropTypes.bool.isRequired,
        profile: PropTypes.shape({
            profile: PropTypes.shape({
                id: PropTypes.number.isRequired,
                status: PropTypes.string.isRequired,
            }),
        }),
        onEditProfile: PropTypes.func,
        onRequestPublish: PropTypes.func.isRequired,
        onRequestUnpublish: PropTypes.func.isRequired,
    };

    render() {
        if (!this.props.isProfileOwner) {
            return null;
        }

        const profileId = this.props.profile
            ? this.props.profile.profile.id
            : '';

        return (
            <SecondBar>
                <div className="panel">
                    <p>{i18n.previewText}</p>

                    <Link
                        className="button"
                        onClick={this.props.onEditProfile}
                        to={createUrl(`/company/${profileId}/edit`)}
                    >
                        {i18n['Edit link']}
                    </Link>
                    <EditProfileStatus
                        isSaving={this.props.profile.isSaving}
                        onRequestPublish={this.props.onRequestPublish}
                        onRequestUnpublish={this.props.onRequestUnpublish}
                        profileId={this.props.profile.profile.id}
                        status={this.props.profile.profile.status}
                    />
                </div>
            </SecondBar>
        );
    }
}
